import React, { Component, useEffect, useState } from 'react';
import FlatList from 'flatlist-react';
import DrawerCustom from '../../components/DrawerCustom';
import ButtonCustom from '../../components/ButtonCustom';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, Menu, ListItem, ListItemIcon, ListItemText, Button, ListItemSecondaryAction, IconButton, InputBase } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { AddCommentIcon, BackOnPrimaryIcon, DeliveryIcon, DeleteWhiteIcon, WalletWhiteIcon, SwichGreenActiveIcon, SwichIcon, CardIcon, EditWhiteMDIcon, RadioCheckedWhiteIcon } from '../../components/icons'
import { getAppCfg, getLogo } from '../../utils/common';
import InfiniteScroll from 'react-infinite-scroll-component';
import CrossellProductsComponent from './CrossellProductsComponent';
import CustomizedCircularProgress from '../../components/CircularProgress';
import FormSerialOTP from '../../components/FormSerialOTP';
import { domainName } from '../../../portal.config';
const styles = theme => ({
    container: {
        padding: theme.spacing(3, 8, 3, 8),
        [theme.breakpoints.down('xs')]:{
            padding: theme.spacing(3, 5, 3, 5)
        }
    },
    buttonBack: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: theme.palette.background.tertiary,
        borderRadius: theme.spacing(8),
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        position: 'absolute',
        top: theme.spacing(5),
        right: theme.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    cart_content: {
        marginTop: theme.spacing(20)
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '47%',// lấy chỉ số width ở drawer x 90%
        [theme.breakpoints.down('md')]:{
            width: '54%'
        },
        [theme.breakpoints.down('sm')]:{
            width: '63%'
        },
        [theme.breakpoints.down('xs')]:{
            width: '81%'
        }     
    },
    footerWithAddNote:{
        position: 'absolute',
        bottom: theme.spacing(15),
        width: '90%',
    },
    item_image: {
        width: 50,
        height: 50,
        objectFit: 'containt',
        borderRadius: 50,
        [theme.breakpoints.down('xs')]:{
            width: 40,
            height: 40,
        }
    },
    item_image_container: {
        width: 60,
        height: 60,
        borderRadius: 60,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
        [theme.breakpoints.down('xs')]:{
            width: 45,
            height: 45,
            marginRight: theme.spacing(3),
        }
    },
    item_icon_container: {
        marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.background.tertiary,
    },
    item: {
        // padding: theme.spacing(0,5,0,5),
        margin: theme.spacing(5, 0, 5, 0),
    },
    add_note: {
        margin: theme.spacing(5, 0, 5, 0),
        cursor: 'pointer',
    },
    add_note_content:{
        minHeight: theme.spacing(20),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        padding: theme.spacing(4)
    },
    button_Place:{
        margin: theme.spacing(4,0,0,0)
    },
    bg_icon:{
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(6),
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        backgroundColor: theme.palette.icon.trash,
        cursor: "pointer",
        touchAction: "manipulation",
    },
    bg_square: {
       // width: theme.spacing(6),
       // height: theme.spacing(6),
        borderRadius: theme.spacing(1),
        backgroundColor:  theme.palette.background.secondary,
        // /marginRight: main_styles.margin.mg_unit3x,
        justifyContent: 'center',
        alignItems: "center"
    },
    bt_funds:{
        cursor: 'pointer'
    },
    payment:{
        cursor: 'pointer',
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(3),
        position: 'relative',
        zIndex: 9,
    },
    inputFund:{
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1),
        width: theme.spacing(18),
        height: theme.spacing(10),
        fontSize: theme.spacing(5)
    },
    wraptext: {
        lineHeight:'1.25em',
        // height:'2em',
        overflow: "hidden",
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical'
    },
    notes: {
        width: 400,
        [theme.breakpoints.down('lg')]:{
            width: 300,
        },
        [theme.breakpoints.down('xs')]:{
            width: 150,
        }
    }
})

function CartsView(props) {
    const { classes, t, currency, open, onClose, carts, estimate_order_result,showAddNote,onClickAddNote, handleOnChangeAddNote, notes, estimate_cart_items } = props;
    var deliveryItem = estimate_order_result&&estimate_order_result.invoice_estimate && estimate_order_result.invoice_estimate.line_items.length > 1 ? dataUtil.getDeliveryItem(estimate_order_result.invoice_estimate.line_items) : null;
    
    
    const appConfig = getAppCfg()
    
    var invoice_estimate = estimate_order_result&&estimate_order_result.invoice_estimate?estimate_order_result.invoice_estimate:null;
    var allow_wallet_funds_payment = appConfig && appConfig.features && appConfig.features.ordering_details && appConfig.features.ordering_details.allow_wallet_funds_payment;
    var allow_specific_funds_amount = appConfig && appConfig.features && appConfig.features.ordering_details && appConfig.features.ordering_details.allow_specific_funds_amount;
    console.log('estimate_order_result===',estimate_order_result)

    let order_summary = dataUtil.getOrderSummary(estimate_order_result, props.isUseWalletFund, props.request_amount_from_wallet_funds, props.isValidAmountWalletFund);

    var payment_label = t('select_payment_method')
    var payment_sub_label = t('Tap_here_to_continue')
    if(props.paymentMethod==='CASH'){
        if(props.order_type==='DELIVERY')
            payment_label= t('Cash_on_delivery')
        else
            payment_label= t('Cash_on_pikup')

        payment_sub_label = ''//t('Please_check_cash')
    }
    else if(props.paymentMethod==='CARD' && props.primary_card){
        payment_label = t('Card')+ '**** **** ****'+ (props.primary_card.card ? props.primary_card.card.last4 : "")
        payment_sub_label = ''//t('Please_check_card')
    }
    else if (props.paymentMethod === 'VNPAY'){
        payment_label = t('Payment with VNPay')
        payment_sub_label = ''
    }
    else if (props.paymentMethod === 'WALLET') {
        payment_label = t('Payment with Paypal')
        payment_sub_label = ''
    }
    console.log("estimate_cart_items:", estimate_cart_items);
    // console.log('CartsView crosssellProducts======',props.crosssellProducts)
    return (
        <DrawerCustom large fullScreen open={open} onClose={onClose}>
            <Grid xs={12} item className={classes.container}>
                <Grid xs={12} item container justify='flex-end' onClick={() => props.onGoBack('menu')}>
                    <Grid color='gray' className={classes.buttonBack}>
                        <BackOnPrimaryIcon />
                    </Grid>
                </Grid>
                <Grid xs={12} item className={classes.cart_content}>
                    <Typo mg_top_lg variant='h3' color='onPrimary'>{t('cart')}</Typo>
                </Grid>
                <Grid xs={12} item>
                    <InfiniteScroll  dataLength={estimate_cart_items.length} height={showAddNote ? '60vh' : '70vh'}>
                        <CartContent cart={estimate_cart_items} classes={classes} t={t} currency={currency} onRemoveItem={props.onRemoveItem} editCartItem={props.editCartItem}/>
                            {props.loadingCrosssell&&<CustomizedCircularProgress/>}
                            {props.crosssellProducts && props.crosssellProducts.length > 0 && <CrossellProductsComponent currency={props.currency} crossellProducts={props.crosssellProducts} onSelectCrossellProduct={props.onSelectCrossellProduct}/>}
                        <Grid item xs={12} container onClick={props.onSelectPaymentMethod} className={classes.payment} direction='row'>
                                <CardIcon/>
                                <Grid item>
                                    <Typo mg_left_xs variant='subtitle2'  color='onPrimary'>{payment_label}</Typo>
                                    <Typo mg_left_xs variant='body2' color='label'>{payment_sub_label}</Typo>
                                </Grid>
                        </Grid>
                        {/* {domainName == 'homespot' && <FormSerialOTP />} */}
                        {deliveryItem && <DeliveryItem item={deliveryItem} classes={classes} t={t} currency={currency} />}
                        <Grid xs={11} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <Typo variant='body1' color='onPrimary'>{t('sub_total')}:</Typo>
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                <Typo mg_left_md variant='h6' color='onPrimary'>{currency}{order_summary.subTotalAmount.toFixed(2)}</Typo>
                            </Grid>
                        </Grid>
                        {props.isUseWalletFund && <Grid xs={11} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <Typo variant='body1' color='onPrimary'>{t('to_be_paid_with_funds')}:</Typo>
                                
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                {allow_specific_funds_amount && !props.edit_amount_form && <Grid item className={classes.bt_funds}  onClick={()=>props.onShowEditWalletFundAmount('edit')}><EditWhiteMDIcon /></Grid>}
                                <Typo mg_left_md variant='h6' color='onPrimary'>{'- '}{currency}{order_summary.wallet_funds_amount? order_summary.wallet_funds_amount.toFixed(2) : "0.00"}</Typo>

                            </Grid>
                        </Grid>}
                        {props.edit_amount_form && <Grid xs={11} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <ButtonCustom color='onPrimary' size='sm' onClick={()=>props.onShowEditWalletFundAmount('cancel')}>{t('Cancel')}</ButtonCustom>
                                <ButtonCustom color='danger' size='sm' onClick={()=>props.onShowEditWalletFundAmount('save')} disabled={!props.isValidAmountWalletFund}>{t('Save')}</ButtonCustom>
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                <InputBase type='number' color='primary' fullWidth className={classes.inputFund} autoFocus value={props.input_field_value} onChange={(event)=>props.handleChangeNumberFund(event.target.value)}/>
                            </Grid>
                        </Grid>}
                        {props.isValidAmountWalletFund===false && <Grid xs={11} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Typo mg_left_md variant='body2' color='error'>{t('REQUEST_WALLET_FUNDS_AMOUNT_INVALID')}{props.availabelWalletFund?props.availabelWalletFund.toFixed(2): '0.00'}</Typo>
                        </Grid>}
                        { order_summary.total_discount_amount>0 && <Grid xs={11} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <Typo variant='body1' color='onPrimary'>{t('promotion_discount')}:</Typo>
                                
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                <Typo mg_left_md variant='h6' color='onPrimary'>{'- '}{currency}{order_summary.total_discount_amount ? order_summary.total_discount_amount.toFixed(2) : "0.00"}</Typo>
                            </Grid>
                        </Grid>}
                        <Grid xs={11} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <Typo variant='body1' color='onPrimary'>{t('amount_due')}:</Typo>
                                
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                <Typo mg_left_md variant='h5' color='onPrimary'>{currency}{order_summary.amountDue ? order_summary.amountDue.toFixed(2) : "0.00"}</Typo>
                            </Grid>
                        </Grid>
                        {allow_wallet_funds_payment && <Grid xs={11} item container justify='flex-end' alignItems='flex-end' className={classes.item}>
                            <Grid xs={9} lg={10} item container direction='row' justify='flex-end' alignItems='flex-end'>
                                <WalletWhiteIcon />
                                <Typo mg_left_md variant='body1' color='onPrimary'>{t('use_funds_from_wallet')}:</Typo>
                            </Grid>
                            <Grid xs={3} lg={2} item container justify='flex-end' alignItems='flex-end'>
                                <Grid item onClick={props.onUseWalletFund} className={classes.bt_funds}>
                                        {props.isUseWalletFund ? <SwichGreenActiveIcon/> : <SwichIcon/>}
                                </Grid>
                            </Grid>    
                        </Grid>}
                    </InfiniteScroll>
                </Grid>
                <Grid item xs={12} className={classes.footer} container>
                    <Grid item xs={12} container direction='row' className={classes.add_note} onClick={onClickAddNote}>
                        <AddCommentIcon />
                        <Typo mg_left_md variant='subtitle1' color='onPrimary'>{t('add_notes')}</Typo>
                    </Grid>

                    {showAddNote&&<Grid item xs={12} className={classes.add_note_content}>
                        <InputBase multiline color='primary' fullWidth autoFocus placeholder={t('note_place_holder')} value={notes} onChange={(event)=>handleOnChangeAddNote(event)}/>
                    </Grid>}
                    <Grid item xs={12}>
                        <ButtonCustom fullWidth color='primary' onClick={()=>props.onPlaceOrder(props.isValidAmountWalletFund,props.request_amount_from_wallet_funds)} className={classes.button_Place} disabled={!props.paymentMethod||(props.paymentMethod==='CARD' && !props.primary_card)} >{t('place_order')}</ButtonCustom>
                    </Grid>
                </Grid>
            </Grid>
        </DrawerCustom>
    )
}

function DeliveryItem(props) {
    const { classes, t, item, currency } = props;
    //console.log('DeliveryItem====',item)
    return (
        <Grid xs={11} item container direction='row' className={classes.item}>
            <Grid xs={9} item container direction='row' alignItems='center'>
                <div className={classes.item_icon_container}>
                    <DeliveryIcon />
                </div>
                <Typo variant='subtitle1' color='onPrimary' mg_right_lg />
                <Grid item>
                    <Typo variant='subtitle1' mg_left_lg color='onPrimary'>{item.product.name}</Typo>
                </Grid>
            </Grid>
            <Grid xs={3} item container justify='flex-end' alignItems='center'>
                <Typo variant='subtitle1' color='onPrimary'>{currency}{item.unit_price ? item.unit_price.toFixed(2) : "0.00"}</Typo>
            </Grid>
        </Grid>
    )
}

function CartItemImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.item_image} src={props.image.url} />
    } return <img className={props.classes.item_image} src={getLogo()} />;;
}
function CartContent(props) {
    const { classes, t, cart, currency,editCartItem } = props;
 
    const getComponent = items => {
        var componentStr = '';
        items.forEach(item => {
            componentStr = componentStr + item.name + ", ";
        });
        if (componentStr) {
            componentStr = componentStr.substr(0, componentStr.length - 2);
        }
        return componentStr;
    }
    const getVariants = items => {
        var variantStr = '';
        items.forEach(item => {
            variantStr = variantStr + item.value + ", ";
        });
        if (variantStr) {
            variantStr = variantStr.substr(0, variantStr.length - 2);
        }
        return variantStr;
    }
    return <FlatList
        list={cart}
        renderItem={(item) =>
            <Grid xs={12} item container direction='row' className={classes.item}>
                <Grid xs={8} item container direction='row' alignItems='center' onClick={() => item.variations ? editCartItem(item): undefined}>
                    <div className={classes.item_image_container}>
                        <CartItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.product_item)} />
                    </div>
                    <Typo variant='subtitle1' color='onPrimary' mg_right_lg>{item.quantity}x</Typo>
                    <Grid item>
                        <Grid xs={12} item>
                            <Typo variant='body2' color='onPrimary'>{item.name}</Typo>
                        </Grid>
                        {item.variant_selected && item.variant_selected.length > 0 && <Grid xs={12} item><Typo variant='description' color='onPrimary'>{getVariants(item.variant_selected)}</Typo></Grid>}
                        {item.components && item.components.length >0 && <Grid xs={12} item><Typo variant='description' color='label'>{getComponent(item.components)}</Typo></Grid>}
                        <Grid xs={12}>
                        {item.notes && <Grid item xs={12} className={classes.notes}><Typo variant='description' color='onPrimary' className={classes.wraptext}>{t('notes')} {item.notes}</Typo></Grid>}
                    </Grid>
                    </Grid>

                </Grid>
                <Grid xs={3} item container justify='flex-end' alignItems='center' onClick={() => item.variations ? editCartItem(item): undefined}>
                    <Typo variant='subtitle1' mg_right_xs color='onPrimary'>{currency}{item.totalAmount?item.totalAmount.toFixed(2): '0.00'}</Typo>
                </Grid>
                <Grid xs={1} item container justify='flex-end' alignItems='center'>
                    <div className={classes.bg_icon} onClick={() => props.onRemoveItem(item)}>
                        <DeleteWhiteIcon />
                    </div>
                </Grid>
            
            </Grid>

        }
    />
}
export default withStyles(styles)(withTranslation()(CartsView))